import { Address, Discount, BoxItem } from "./types";

type DateAddressMapping = {
  [mdyAddr: string]: BoxItem[];
};

export type Box = {
  nextChargeDate: Date;
  address: Address;
  items: BoxItem[];
  id: string;
  discount?: Discount;
};

export class BoxSchedule {
  private boxSchedule: Box[];

  constructor(items: BoxItem[]) {
    const discountedAddresses = new Set<number>();
    const addressGroups = groupItemsByDateAddress(items);

    const sortedAdressKeys = Object.keys(addressGroups).sort();
    this.boxSchedule = sortedAdressKeys.map((id) => {
      const dateStr = id.split("|")[0];
      const nextChargeDate = new Date(dateStr);
      const items = addressGroups[id];
      const address = items[0].address;
      const canApplyDiscount = !discountedAddresses.has(address.id);
      discountedAddresses.add(address.id);
      const discount = canApplyDiscount ? address.discount : undefined;
      return {
        nextChargeDate,
        address,
        items,
        id,
        discount,
      };
    });
  }

  getScheduleAscending(): Box[] {
    return this.boxSchedule;
  }
}

export const groupItemsByDateAddress = (
  items: BoxItem[]
): DateAddressMapping => {
  const nextChargeSubsDesc = items.sort(
    (a, b) =>
      b.rechargeItem.nextChargeDate.getTime() -
      a.rechargeItem.nextChargeDate.getTime()
  );

  return nextChargeSubsDesc.reduce((acc, boxItem) => {
    const lastDate = nextChargeSubsDesc[0].rechargeItem.nextChargeDate;
    let currentDate = boxItem.rechargeItem.nextChargeDate;
    do {
      const dateAddr = currentDate.toISOString() + "|" + boxItem.address.id;
      if (acc[dateAddr]) {
        acc[dateAddr].push(boxItem);
      } else if (currentDate === boxItem.rechargeItem.nextChargeDate) {
        acc[dateAddr] = [boxItem];
      }

      if (!boxItem.rechargeItem.cadence) {
        break;
      }

      let nextDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + boxItem.rechargeItem.cadence.frequency,
        currentDate.getDate()
      );
      // if the days are not equal after month inc, it's because day was > days in month
      if (nextDate.getDate() !== currentDate.getDate()) {
        // sets date to last day of prev month
        nextDate.setDate(0);
      }
      currentDate = nextDate;
    } while (currentDate.getTime() <= lastDate.getTime());
    return acc;
  }, {} as DateAddressMapping);
};
